import React, {FC, PropsWithChildren} from 'react';

export const PageContentWrapper: FC<PropsWithChildren> = ({children}) => {
  return (
    <div className="bg-white rounded-t-30 sm:rounded-t-40 md:rounded-t-50 flex flex-1 flex-col pt-7 pb-10 px-3 sm:px-5 md:px-10 h-full">
      {children}
    </div>
  );
};
